import { DrawingTool } from "@/types/enum";
import { create } from "zustand";

interface DrawingState {
  activeTool: DrawingTool;
  setActiveTool: (tool: DrawingTool) => void;
  offsetTargetFeatureId: string | null;
  setOffsetTargetFeatureId: (featureId: string | null) => void;
}

const useDrawingStore = create<DrawingState>((set) => ({
  activeTool: DrawingTool.NONE,
  setActiveTool: (tool) => set({ activeTool: tool }),
  offsetTargetFeatureId: null,
  setOffsetTargetFeatureId: (featureId) =>
    set({ offsetTargetFeatureId: featureId }),
}));

export default useDrawingStore;
